export function numberSeparator (value: number, determine = ' '): string {
  return value
    ? value.toString()
      .replace(/\B(?=(\d{3})+(?!\d))/g, `${determine}`)
    : '0';
}
